import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AuthorizationServicesEnum, OwsClientService, OwsJSON, OwsServiceErrorResponse } from 'ows-library';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { Router } from '@angular/router';
import { GlobalService } from 'app/compartilhado/servicos/global.service';
import { ProvedorCobrancaNome } from '../agendamento-go-form/models/ProvedorCobrancaNomeEnum';
import { DadosPagamentoModel } from '../agendamento-go-form/models/DadosPagamento.model';
import { PagamentoService } from 'app/compartilhado/componentes/pagamento-form/pagamento.service';

export class ConfirmarPesquisaModel {
  EmpresaId = '';
  EmpresaCnpj = '';
  EmpresaNome = '';
  EmpresaCep = '';
  EmpresaUF = '';
  EmpresaLogradouro = '';
  EmpresaComplemento = '';
  EmpresaBairro = '';
  EmpresaNumero = '';
  EmpresaMunicipio = '';
  Placa = '';
  Renavam = '';
  CpfCnpj = '';
  VeiculoPorte = '';
  Nome = '';
  Email = '';
  TelefoneDDD = '';
  Telefone = '';
  Status = '';
  DataHoraInicio = '';
  DataHoraFim = '';
  ModalidadeVistoria = '';
  ModalidadeVistoriaDescricao = '';
  RecaptchaSiteKey = '';
}

export class ConfirmarRepostaModel {
  ProvedorCobrancaChave: string;
  AgendamentoVistoriaId: string;
  PossuiProvedorCobrancaChave: boolean;
  PossuiProvedorCobrancaChaveSecundaria: boolean;
  VistoriaValor: string;
  ProvedorCobrancaNome: ProvedorCobrancaNome;
}

@Injectable()
export class AgendamentoMTService {

  listaMunicipios = [];
  listaLocaisVistoria = [];
  municipiosChanged = new Subject<any>();
  locaisVistoriaChanged = new Subject<any>();
  agendamentosChanged = new Subject<any>();
  cadastroChanged = new Subject<any>();
  pagamentoChanged = new Subject<any>();
  falhaPagamentoChanged = new Subject<any>();
  exibirBotoesChanged = new Subject<any>();
  creditoFormChanged = new Subject<any>();
  informacoesLocalSelecionadoChanged = new Subject<any>();
  tipoVistoriaAgendamento;
  municipioAgendamento;
  localVistoriaAgendamento;
  listaTiposVistoria = [{
    Key: 'BS', Value: 'VISTORIA NA LOJA DA ECV'
  }, {
    Key: 'CO', Value: 'VISTORIA EM COMÉRCIO DE VEÍCULOS'
  }, {
    Key: 'PR', Value: 'VISTORIA EM PÁTIO PRIVADO'
  }, {
    Key: 'PB', Value: 'VISTORIA EM PÁTIO PUBLICO'
  }, {
    Key: 'VP', Value: 'VISTORIA DE VEÍCULOS PESADOS (PBT MAIOR QUE 10TN)'
  }];
  listaTiposVeiculos = [{
    Key: 'MT', Value: 'Motocicletas'
  }, {
    Key: 'VL', Value: 'Veículo Leve'
  }, {
    Key: 'VP', Value: 'Veículo Pesado'
  }];
  pesquisaFlag = false;
  consultaPorCnpj = false;
  realizaPagamento = false;
  agendamentoId;
  empresaId;
  cartaoCreditoTokenId = '';
  vistoriaValor;
  dadosPagamento: DadosPagamentoModel = new DadosPagamentoModel();
  confirmaResposta: ConfirmarRepostaModel = new ConfirmarRepostaModel();
  exibePagina = true;
  exibeLocalVistoria = false;
  checkoutUrl;
  provedorCobranca = ProvedorCobrancaNome.ND;
  recaptchaValueMemory;
  agendamentoDados: ConfirmarPesquisaModel = new ConfirmarPesquisaModel();

  constructor(private owsClientService: OwsClientService,
    private popUpService: PopUpService,
    private globalService: GlobalService,
    private pagamentoService: PagamentoService,
    private router: Router) {
  }

  consultarEmpresaPorCnpj(cnpj) {
    this.owsClientService.get<any>('agendamentosvistorias/listarlocaisvistoriasporcnpj', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [
        { key: 'cnpj', value: cnpj },
        { key: 'uf', value: 'MT' }]
    }).subscribe((response) => {
      this.listaLocaisVistoria = response.body.LocaisVistorias;
      this.locaisVistoriaChanged.next(response.body.LocaisVistorias);
    },
      error => {
        this.pesquisaFlag = false;
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  efetuarPagamentoCielo() {
    this.dadosPagamento.AgendamentoId = this.agendamentoId;
    this.dadosPagamento.ProvedorCobrancaNome = this.provedorCobranca;
    this.dadosPagamento.VistoriaValor = this.vistoriaValor;
    this.owsClientService.post<any>('agendamentosvistorias/pagamento', this.dadosPagamento, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.pesquisaFlag = false;
      if (resposta.body && resposta.body.CheckoutUrl) {
        this.checkoutUrl = resposta.body.CheckoutUrl;
        this.pagamentoChanged.next(resposta.body.CheckoutUrl);
      } else {
        this.pagamentoChanged.next(false);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
        this.pesquisaFlag = false;
      });
  }

  efetuarPagamentoCreditoIugu(pagamentoTipo: string) {
    this.pagamentoService.efetuarPagamentoCreditoIugu(pagamentoTipo);
  }

  efetuarPagamentoIuguPixBoleto(pagamentoTipo: string) {
    if (pagamentoTipo == 'C' && this.cartaoCreditoTokenId !== '') {
      this.dadosPagamento.CartaoCreditoTokenId = this.cartaoCreditoTokenId;
    }
    this.dadosPagamento.ProvedorCobrancaNome = this.provedorCobranca;
    this.dadosPagamento.AgendamentoId = this.agendamentoId;
    this.dadosPagamento.VistoriaValor = this.vistoriaValor;
    this.dadosPagamento.PagamentoTipo = pagamentoTipo;
    this.owsClientService.post<any>('agendamentosvistorias/pagamento', this.dadosPagamento, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.pesquisaFlag = false;
      if (resposta.body && resposta.body.CheckoutUrl) {
        this.checkoutUrl = resposta.body.CheckoutUrl;
        this.pagamentoChanged.next(this.checkoutUrl);
      } else {
        this.pagamentoChanged.next(false);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }

        //2116: Campo CPF/CNPJ Inválido.
        if (error.error && error.error.Code == 2116) {
          this.falhaPagamentoChanged.next();
        }

        this.globalService.exibirLoadingPagamento(false);
        this.pesquisaFlag = false;

        if (pagamentoTipo == 'C') {
          this.exibePagina = true;
          this.creditoFormChanged.next();
        }
      });
  }

  confirmarAgendamento() {
    this.pesquisaFlag = true;
    this.owsClientService.post<ConfirmarRepostaModel>('agendamentosvistorias/confirmar', this.agendamentoDados, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.confirmaResposta = resposta.body;
      this.vistoriaValor = this.confirmaResposta.VistoriaValor;
      this.agendamentoId = this.confirmaResposta.AgendamentoVistoriaId;

      if (this.confirmaResposta.ProvedorCobrancaNome !== null) {
        if (this.confirmaResposta.ProvedorCobrancaNome == ProvedorCobrancaNome.CIELO) {
          this.realizaPagamento = this.confirmaResposta.PossuiProvedorCobrancaChave && Number(this.vistoriaValor.replace(',', '.')) > 0;
          this.provedorCobranca = ProvedorCobrancaNome.CIELO;
        } else if (this.confirmaResposta.ProvedorCobrancaNome == ProvedorCobrancaNome.IUGU) {
          this.realizaPagamento = (this.confirmaResposta.PossuiProvedorCobrancaChave || this.confirmaResposta.PossuiProvedorCobrancaChaveSecundaria) &&
            Number(this.vistoriaValor.replace(',', '.')) > 0;
          this.provedorCobranca = ProvedorCobrancaNome.IUGU;
        }
      }

      this.cadastroChanged.next(true);
      this.pesquisaFlag = false;
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
        this.pesquisaFlag = false;
      });
  }

  formatarTelefone(telefone) {
    const telefoneAjustado = telefone.replace(/(\d{2})(\d{5})(\d{4})/,
      function (regex, arg1, arg2, arg3) {
        return arg1 + ' ' + arg2 + '-' + arg3;
      });
    return telefoneAjustado;
  }

  exibirBotoesPagamento() {
    this.exibirBotoesChanged.next(true);
  }

  transfereDadosServicos() {
    if (this.confirmaResposta.PossuiProvedorCobrancaChave) {
      this.pagamentoService.dadosPagamento = this.dadosPagamento;
      this.pagamentoService.dadosPagamento.Nome = this.agendamentoDados.Nome;
      this.pagamentoService.dadosPagamento.Email = this.agendamentoDados.Email;
      this.pagamentoService.dadosPagamento.CpfCnpj = this.agendamentoDados.CpfCnpj;
      this.pagamentoService.dadosPagamento.TelefoneDDD = this.agendamentoDados.TelefoneDDD;
      this.pagamentoService.dadosPagamento.Telefone = this.agendamentoDados.Telefone;
      this.pagamentoService.dadosPagamento.EmpresaId = this.agendamentoDados.EmpresaId;
      this.pagamentoService.dadosPagamento.AgendamentoId = this.agendamentoId;
      this.pagamentoService.dadosPagamento.Placa = this.agendamentoDados.Placa;
      this.pagamentoService.dadosPagamento.CartaoCreditoTokenId = '';
      this.pagamentoService.dadosPagamento.PagamentoTipo = '';
      this.pagamentoService.dadosPagamento.VistoriaValor = this.vistoriaValor;
      this.pagamentoService.dadosPagamento.ProvedorCobrancaNome = this.confirmaResposta.ProvedorCobrancaNome;
      this.pagamentoService.provedorCobrancaChave = this.confirmaResposta.ProvedorCobrancaChave;
    }
  }
}